module.exports = __webpack_public_path__ + "img/electricite.51efddc9.svg";